var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container-fluid"},[_c('card',{staticClass:"is-card-table has-pagination has-bottom-left-hidden"},[_c('bg-table-media',{attrs:{"update":"/re-media","setCurrentFolder":_vm.currentFolder}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }